export class RootNode {

    constructor() {
        this.children = []
    }

}